var __default__ = {eyeDropperIcon:'m_b077c2bc',colorPreview:'m_c5ccdcab',dropdown:'m_5ece2cd7'};
export default __default__;